import React, { useContext } from "react";
import {
  ApiErrorHandler,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import Toggle from "../../../common/Toggle/Toggle";
import {
  IGroupInfo,
  INonPatientChats,
  IPatientChats,
} from "@home-health-notify/domain";
import { IUpdateVisibleToPhysicianRequest } from "@home-health-notify/models";
import { useSnackbar } from "notistack";

const VisibleToPhysicianToggle = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  const visibleToPhysician = groupInfo.settings?.visibleToPhysician || false;
  const { selectedOrgUser } = useContext(OrganizationContext);
  const { enqueueSnackbar } = useSnackbar();

  const getRequestPayload = () => {
    const requestPayload: IUpdateVisibleToPhysicianRequest = {
      id: groupInfo.id,
      settings: {
        visibleToPhysician: !visibleToPhysician,
      },
    };
    return requestPayload;
  };

  const onVisibleToPhysician = async () => {
    try {
      const chatManager =
        selectedOrgUser?.chatManager.getChatManagerForGroupType(
          groupInfo.groupType,
        ) as IPatientChats | INonPatientChats;
      await chatManager.updateVisibleToPhysician(getRequestPayload());
      enqueueSnackbar("Visible to physician has been updated", {
        autoHideDuration: 3000,
      });
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar);
    }
  };

  return (
    <Toggle
      label={tNs("visibleToPhysician")}
      onToggle={onVisibleToPhysician}
      checked={visibleToPhysician}
    />
  );
};

export default VisibleToPhysicianToggle;
